import React from 'react';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// Import the functions you need from the SDKs you need
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCgVo60UOm2fWFDRjY_X6aK8s8QZV9lZxo',
  authDomain: 'tanelog-c138b.firebaseapp.com',
  projectId: 'tanelog-c138b',
  storageBucket: 'tanelog-c138b.appspot.com',
  messagingSenderId: '905093591853',
  appId: '1:905093591853:web:70be5c5dd9b12cc4cf19a4',
  measurementId: 'G-4JBFQMVKL5',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
